import React from "react";
import "./styles.css";

const QuestionReviewNotAnswered = ({
  width,
  height,
  customCss = {},
  children,
}) => {
  return (
    <div
      className="Review"
      style={{
        ...(width && { width }),
        ...(height && { height }),
        ...customCss,
      }}
    >
      {children}
    </div>
  );
};

export default QuestionReviewNotAnswered;
